import routes from "const/routes";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider as ReactRouterProvider,
} from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

const router = createBrowserRouter([
  {
    element: (
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Outlet />
      </QueryParamProvider>
    ),
    children: routes,
  },
]);

const RouterProvider: React.FC = () => <ReactRouterProvider {...{ router }} />;

export default RouterProvider;
